import type { RemoteConfigValues } from 'src/interfaces/remoteConfig'
import type { State } from 'src/reducers/types'

export const getRemoteConfigValues = (state: State): RemoteConfigValues => {
  return state.remoteConfig.values
}

export const getRemoteConfigIsLoaded = (state: State): boolean => {
  return state.remoteConfig.isLoaded
}
